/* ============================================================
   URINKING · Hero-Slider
   Angelegt 29.07.2026

   Dieses Skript ist BEIWERK. Das Schieben selbst macht der
   Browser ueber scroll-snap. Faellt das Skript aus, bleibt der
   Hero vollstaendig bedienbar - nur die Punkte zeigen dann
   nicht mehr, welche Folie sichtbar ist.

   Zwei Aufgaben:
   1. Punkte mit der sichtbaren Folie abgleichen und anspringen
   2. Videos anhalten, wenn der Besucher Bewegung reduziert hat
      (harte Regel 13). CSS kann ein Video nicht stoppen.
   ============================================================ */

(function () {
  'use strict';

  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)');

  function videosRegeln(wurzel) {
    var videos = wurzel.querySelectorAll('.uk-hero__video');
    Array.prototype.forEach.call(videos, function (v) {
      if (ruhig.matches) {
        // Vorschaubild stehen lassen, nichts abspielen.
        v.removeAttribute('autoplay');
        v.pause();
        v.currentTime = 0;
      } else if (v.paused) {
        // play() kann abgelehnt werden, etwa bei Energiesparmodus.
        // Dann bleibt das poster-Bild stehen, was in Ordnung ist.
        var p = v.play();
        if (p && typeof p.catch === 'function') { p.catch(function () {}); }
      }
    });
  }

  function punkteVerdrahten(sektion) {
    var spur = sektion.querySelector('.uk-hero__spur');
    var leiste = sektion.querySelector('.uk-hero__punkte');
    if (!spur || !leiste) { return; }

    var punkte = leiste.querySelectorAll('.uk-hero__punkt');
    var folien = spur.querySelectorAll('.uk-hero__folie');
    if (!punkte.length || !folien.length) { return; }

    function setzeAktiv(index) {
      Array.prototype.forEach.call(punkte, function (p, i) {
        if (i === index) { p.setAttribute('aria-current', 'true'); }
        else { p.removeAttribute('aria-current'); }
      });
    }

    Array.prototype.forEach.call(punkte, function (punkt) {
      punkt.addEventListener('click', function () {
        var ziel = folien[parseInt(punkt.dataset.ziel, 10)];
        if (!ziel) { return; }
        spur.scrollTo({
          left: ziel.offsetLeft - spur.offsetLeft,
          behavior: ruhig.matches ? 'auto' : 'smooth'
        });
      });
    });

    // Welche Folie ist sichtbar? Ueber IntersectionObserver statt
    // ueber ein scroll-Ereignis - das feuert sonst dutzendfach je
    // Wischbewegung.
    if ('IntersectionObserver' in window) {
      var beobachter = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio >= 0.6) {
            setzeAktiv(parseInt(e.target.dataset.folie, 10));
          }
        });
      }, { root: spur, threshold: [0.6] });

      Array.prototype.forEach.call(folien, function (f) { beobachter.observe(f); });
    }
  }

  function start() {
    var sektionen = document.querySelectorAll('.uk-hero');
    Array.prototype.forEach.call(sektionen, function (s) {
      punkteVerdrahten(s);
      videosRegeln(s);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  // Umschalten im Betrieb beruecksichtigen (Systemeinstellung geaendert)
  if (typeof ruhig.addEventListener === 'function') {
    ruhig.addEventListener('change', function () {
      Array.prototype.forEach.call(document.querySelectorAll('.uk-hero'), videosRegeln);
    });
  }

  // Der Theme-Editor baut Sektionen neu auf, ohne die Seite zu laden.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('.uk-hero')) { start(); }
  });
})();
